import { render, staticRenderFns } from "./BusMaster.vue?vue&type=template&id=c1e2c6f2&"
import script from "./BusMaster.vue?vue&type=script&lang=js&"
export * from "./BusMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports